import { Button } from "@adafia/ui";
import { FolderPlus, Plus } from "lucide-react";
import { useCreateNode } from "@/notes/hooks/useCreateNode";
import type { FileNode } from "../../types";
import "./SideBarActions.css";

export const SidebarActions = ({
	parentId,
	onCreated,
}: {
	parentId: string | null;
	onCreated: (node: FileNode) => void;
}) => {
	const { mutate: createNode } = useCreateNode();

	const createFolder = () => {
		createNode(
			{ title: "New Folder", content: null, isFolder: true, parentId },
			{ onSuccess: onCreated },
		);
	};

	const createNote = () => {
		createNode(
			{ title: "New Note.md", content: "", isFolder: false, parentId },
			{ onSuccess: onCreated },
		);
	};

	return (
		<div className="sidebar-actions-container">
			<Button
				onClick={createNote}
				variant="secondary"
				className="action-button"
				title="New Note"
			>
				<Plus size={18} />
			</Button>
			<Button
				onClick={createFolder}
				variant="secondary"
				className="action-button"
				title="New Folder"
			>
				<FolderPlus size={18} />
			</Button>
		</div>
	);
};
